export default __webpack_public_path__ + "static/media/money-stack-icon.60b0c2b7.svg";